import React, { ReactNode } from 'react';
import { Platform, usePlatform } from 'utils/hooks/usePlatform';

import { activeNotification } from 'components/functions/activeNotification';

export interface ExtraAction {
    onClick: (event: MouseEvent) => void;
    children: ReactNode;
    isBlocked?: boolean;
}

export const generateOfferActionsElements = (offerLink: string, originalOfferLink: string, extraActions?: ExtraAction[], isOfferLinkValid = true) => {
    const platform = usePlatform();

    return [
        {
            children:
                <>
                    <p>Skopiuj link</p>
                </>,
            onClick: async (e: MouseEvent) => {
                e.stopPropagation();

                await navigator.clipboard.writeText(offerLink);
                activeNotification('Skopiowano', 'Link został pomyślnie skopiowany', 'success');
            }
        },

        ...platform === Platform.Web
            ? [
                {
                    children:
                <>
                    <p>Otwórz w nowej karcie</p>
                </>,
                    isBlocked: !isOfferLinkValid,
                    onClick: async (e: MouseEvent) => {
                        e.stopPropagation();

                        window.open(offerLink, '_blank');
                    }
                }
            ]
            : [],
        {
            children:
                <>
                    <p>Przejdź do ogłoszenia na portalu</p>
                </>,
            onClick: async (e: MouseEvent) => {
                e.stopPropagation();

                window.open(originalOfferLink, '_blank');
            }
        },
        ...extraActions || []
    ];
};
